import { useMemo, useRef } from 'react';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';

import { AppInitialState, rootReducer } from '@/store';

export const useStore = (initialState: AppInitialState): Store => {
	const storeRef = useRef<Store | null>(null);
	const initialStateRef = useRef<string>('');

	const store = useMemo(() => {
		const newInitialStateString = JSON.stringify(initialState);

		// If we have an existing store and initialState hasn't meaningfully changed, keep it
		if (storeRef.current && initialStateRef.current === newInitialStateString) {
			return storeRef.current;
		}

		// Create new store with fresh initial state
		const newStore = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(reduxThunk)));

		// Store references for next comparison
		storeRef.current = newStore;
		initialStateRef.current = newInitialStateString;

		return newStore;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(initialState)]);

	return store;
};
